import { FullScreenDialog } from "@src/appV2/lib";
import type { UseModalState } from "@src/appV2/redesign/system/ui-components";

import { RestrictedAccountContent } from "./RestrictedAccountContent";

interface RestrictedBottomSheetProps {
  readonly modalState: UseModalState;
  readonly isFinalRestriction: boolean;
  readonly liftTime?: string;
  readonly reEnrollmentScore: number;
  readonly onContinue: () => void;
  readonly isLimitedAccessWorker?: boolean;
}

export function RestrictedBottomSheet(props: RestrictedBottomSheetProps) {
  const {
    modalState,
    isFinalRestriction,
    liftTime,
    reEnrollmentScore,
    onContinue,
    isLimitedAccessWorker,
  } = props;

  return (
    <FullScreenDialog
      modalState={modalState}
      variant="tertiary"
      PaperProps={{
        sx: {
          background:
            // eslint-disable-next-line cbh-rules/no-inline-gradient -- TODO: migrate to theme palette gradient
            "linear-gradient(180deg, rgba(251, 242, 232, 1) 0%, rgba(247, 208, 208, 1) 100%)",
        },
      }}
    >
      <RestrictedAccountContent
        enableViewAnalytics={modalState.modalIsOpen}
        isFinalRestriction={isFinalRestriction}
        liftTime={liftTime}
        reEnrollmentScore={reEnrollmentScore}
        isLimitedAccessWorker={isLimitedAccessWorker}
        onContinue={onContinue}
      />
    </FullScreenDialog>
  );
}
